import React, { useState } from "react";

const HoseAssemblySection = (props) => {
  const {formData, setFormData, errors} = props;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  return (
    <>
      <div className="row">
        <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Hose Assembly</h4>
            </div>
            <div className="card-body">
                <div className="mb-3 row">
                  <div className="col-md-4">
                    <label className="col-form-label">Hose Brand</label>
                    <input
                      name="hose_brand"
                      value={formData.hose_brand}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Hose Brand"
                    />
                    {errors.hose_brand && (
                      <span className="text-danger fs-12">{errors.hose_brand}</span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">Hose Type</label>
                    <input
                      name="hose_type"
                      value={formData.hose_type}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Hose Type"
                    />
                    {errors.hose_type && (
                      <span className="text-danger fs-12">{errors.hose_type}</span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">Fitting-A</label>
                    <input
                      name="fitting_a"
                      value={formData.fitting_a}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Fitting-A"
                    />
                    {errors.fitting_a && (
                      <span className="text-danger fs-12">{errors.fitting_a}</span>
                    )}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-md-4">
                    <label className="col-form-label">Fitting-B</label>
                    <input
                      name="fitting_b"
                      value={formData.fitting_b}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Fitting-B"
                    />
                    {errors.fitting_b && (
                      <span className="text-danger fs-12">{errors.fitting_b}</span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">Assembly Length</label>
                    <input
                      name="assembly_length"
                      value={formData.assembly_length}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Assembly Length"
                    />
                    {errors.assembly_length && (
                      <span className="text-danger fs-12">{errors.assembly_length}</span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">Fitting Length</label>
                    <input
                      name="fitting_length"
                      value={formData.fitting_length}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Fitting Length"
                    />
                    {errors.fitting_length && (
                      <span className="text-danger fs-12">{errors.fitting_length}</span>
                    )}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-md-4">
                    <label className="col-form-label">Cut Length</label>
                    <input
                      name="cut_length"
                      value={formData.cut_length}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Cut Length"
                    />
                    {errors.cut_length && (
                      <span className="text-danger fs-12">{errors.cut_length}</span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">Orientation Angle</label>
                    <input
                      name="orientation_angle"
                      value={formData.orientation_angle}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Orientation Angle"
                    />
                    {errors.orientation_angle && (
                      <span className="text-danger fs-12">
                        {errors.orientation_angle}
                      </span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">Hose Protection</label>
                    <input
                      name="hose_protection"
                      value={formData.hose_protection}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      placeholder="Enter Hose Protection"
                    />
                    {errors.hose_protection && (
                      <span className="text-danger fs-12">
                        {errors.hose_protection}
                      </span>
                    )}
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HoseAssemblySection;
